import React, { useState } from 'react';
import '../styles/pages/FAQ.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      category: "General",
      questions: [
        {
          q: "What is LCS System ?",
          a: "LCS is India's leading KYC Verification services platform that provides PAN verification, KYC services, Age Verification, Instant business verification, Document verification and court case checks for businesses and financial institutions."
        },
        {
          q: "Who can use LCS services?",
          a: "Banks, NBFCs, Microfinance institutions, Fintech companies, Insurance companies, and other RBI-registered financial institutions can use our services for KYC assessment and verification."
        },
        {
          q: "How do I register on the platform?",
          a: "Fill the registration form on the Contact Us page or email us at register@lcsolution.in. Our admin team will review and approve your request within 24-48 hours. You'll receive login credentials via email."
        }
      ]
    },
    {
      category: "Services & Features",
      questions: [
        {
          q: "How long does it take to generate a KYC Verification report?",
          a: "KYC verification reports are generated in real-time, typically within 3-5 seconds. Bulk uploads may take 2-5 minutes depending on volume."
        }
      ]
    },
    {
      category: "Wallet & Payments",
      questions: [
        {
          q: "How does the wallet system work?",
          a: "Your organization has a prepaid wallet. Top-up using bank transfer or online payment. Each KYC check deducts the applicable cost automatically. Check balance anytime on your dashboard."
        },
        {
          q: "What are the costs for KYC reports?",
          a: "Pricing varies by report type. Typical costs: Basic (₹10-25), Advanced (₹30-50), Combo (₹80-150). Contact sales for volume discounts."
        },
        {
          q: "Are wallet top-ups refundable?",
          a: "Top-ups are non-refundable except in case of technical errors. Unused balance remains valid for 12 months."
        },
        {
          q: "Do wallet funds expire?",
          a: "Funds expire after 12 months of account inactivity. Active accounts retain balance indefinitely."
        }
      ]
    },
    {
      category: "KYC Checks & Reports",
      questions: [
        {
          q: "What information do I need to run a credit check?",
          a: "Required: Full Name, Date of Birth, PAN Number. Optional: Phone, Address (improves match accuracy)."
        },
        {
          q: "What if the KYC report shows 'No Record Found'?",
          a: "This means the API has no  history for the individual. They may be details may not match as per records."
        },
        {
          q: "Can I download reports in PDF format?",
          a: "Yes! All reports can be downloaded as PDF with your organization's branding."
        },
        {
          q: "How do I verify if someone gave consent for KYC check?",
          a: "You must maintain signed consent forms as per RBI guidelines. Our platform logs all checks with timestamps for audit trails."
        }
      ]
    },
    {
      category: "Technical & Support",
      questions: [
        {
          q: "What browsers are supported?",
          a: "Chrome, Firefox, Safari, Edge (latest versions). Mobile responsive design works on all devices."
        },
        {
          q: "Is the platform secure?",
          a: "Yes! We use bank-grade encryption (AES-256), TLS 1.3, multi-factor authentication, and ISO 27001 certified infrastructure."
        },
        {
          q: "What should I do if I encounter an error?",
          a: "Check your internet connection and wallet balance. If issue persists, contact support@lcsolution.in with error details and screenshot."
        },
        {
          q: "Can I integrate LCS with my existing software?",
          a: "Yes! We offer REST APIs for seamless integration. Contact our tech team for API documentation and credentials."
        }
      ]
    },
    {
      category: "Compliance & Privacy",
      questions: [
        {
          q: "Is LCS MCA compliant?",
          a: "Yes! We strictly follow MCA guidelines for KYC Verification information companies, KYC norms, and data protection regulations."
        },
        {
          q: "How is my data protected?",
          a: "We comply with Digital Personal Data Protection Act, 2023. Data is encrypted, access-controlled, and stored in India. See our Privacy Policy for details."
        },
        {
          q: "Can I request deletion of my organization's data?",
          a: "Account closure requests are honored within 30 days. However, certain data must be retained for 7-10 years for compliance."
        }
      ]
    }
  ];

  return (
    <div className="faq-page">
      <div className="faq-hero">
        <h1>Frequently Asked Questions</h1>
        <p>Find answers to common questions about LCS services</p>
      </div>

      <div className="faq-container">
        <div className="faq-search">
          <input 
            type="text" 
            placeholder="Search for answers..." 
            className="faq-search-input"
          />
        </div>

        {faqs.map((category, catIndex) => (
          <div key={catIndex} className="faq-category">
            <h2 className="faq-category-title">{category.category}</h2>
            <div className="faq-list">
              {category.questions.map((faq, qIndex) => {
                const globalIndex = `${catIndex}-${qIndex}`;
                const isActive = activeIndex === globalIndex;
                
                return (
                  <div 
                    key={qIndex} 
                    className={`faq-item ${isActive ? 'active' : ''}`}
                    onClick={() => toggleFAQ(globalIndex)}
                  >
                    <div className="faq-question">
                      <h3>{faq.q}</h3>
                      <span className="faq-toggle">{isActive ? '−' : '+'}</span>
                    </div>
                    {isActive && (
                      <div className="faq-answer">
                        <p>{faq.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}

        <div className="faq-contact-section">
          <h2>Still have questions?</h2>
          <p>Can't find the answer you're looking for? Our support team is here to help.</p>
          <a href="/contact" className="faq-contact-btn">Contact Support</a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
